import React from 'react';
import { formatPhoneDisplay } from '../utils/phoneFormat';
import styles from './PhoneDisplay.module.css';

interface PhoneDisplayProps {
  phone: string;
}

/**
 * 전화번호 큰 글씨 표시
 * - 입력된 번호는 하이픈 포맷팅하여 표시
 * - 빈 경우 플레이스홀더 표시
 */
export function PhoneDisplay({ phone }: PhoneDisplayProps) {
  const hasInput = phone.length > 0;
  const displayText = hasInput
    ? formatPhoneDisplay(phone)
    : '010-0000-0000';

  return (
    <div className={styles.display}>
      <span className={`${styles.phoneText} ${!hasInput ? styles.placeholder : ''}`}>
        {displayText}
      </span>
    </div>
  );
}
